module.exports = __webpack_public_path__ + "static/the-workroom-8365557a72923fad3e4f752b57d45e47.webm";